/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useContext, useMemo } from 'react';

import { useThemeSwitcher } from 'react-css-theme-switcher';
import doReturnTheme from '../../../styles/themeEngine';

import LeftSideNav from '../../molecules/LeftSideNav/LeftSideNav';
import { LeftSideViewSu } from '~components/molecules/LeftSideViewSu/LeftSideViewSu';
import LeftSideView from '~components/molecules/LeftSideView/LeftSideView';
import { UserOptionsContainer } from '~components/molecules/UserOptionsContainer/UserOptionsContainer';

import AppContext from '~src/contexts/AppContext';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import SidebarContext from '~src/contexts/SidebarContext';
import {
  LEFT_SIDEBAR_WIDTH_CSS,
  MINIMIZED_LEFT_SIDEBAR_WIDTH_CSS,
} from '~src/styles/constants';

const LeftNav = () => {
  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);
  const { isSidebarMinimized } = useContext(SidebarContext);

  const styleFn: ThemedStyleFn = useMemo(
    () => (theme) => ({
      style: {
        backgroundColor:
          window.sessionStorage.getItem('appState') === 'superUser'
            ? theme.colors.primaryLight
            : window.sessionStorage.getItem('appState') === 'timeMachine'
            ? theme.colors.background.primaryLight
            : theme.colors.white,
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        width: isSidebarMinimized
          ? MINIMIZED_LEFT_SIDEBAR_WIDTH_CSS
          : LEFT_SIDEBAR_WIDTH_CSS,
        height: '100%',
        borderRight: `solid 1px ${theme.colors.darkGray}`,
      },
      middleContent: {
        flex: 1,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
      },
    }),
    [theme, isSidebarMinimized]
  );
  const styles = useStyles(styleFn);

  // get the App Context (normal, timeMashine, superUser)
  const { appContextState } = useContext(AppContext);

  return (
    <div css={styles.style}>
      <LeftSideNav />

      <div css={styles.middleContent}>
        {window.sessionStorage.getItem('appState') === 'superUser' ? (
          <LeftSideViewSu />
        ) : (
          <LeftSideView />
        )}
      </div>

      <UserOptionsContainer />
    </div>
  );
};

export default LeftNav;
